// extracted by mini-css-extract-plugin
export default {"text":"ScoreCounter_text__+QJMD","gradient":"ScoreCounter_gradient__V+xYI"};